import 'velocity-animate';
import 'velocity-animate/velocity.ui';

export const OPACITY_DISABLED = 0.2;
export const DURATION_OPACITY_TOGGLE = 300;
export const DURATION_ANIMATED_NUMBER = 750;
export const DURATION_DROPDOWN_TOGGLE = 200;

export const transitionDisableToggleProps = show => ({
  animation: { opacity: show ? 1 : OPACITY_DISABLED },
  duration: DURATION_OPACITY_TOGGLE
});

export const transitionHideToggleProps = show => ({
  animation: { opacity: show ? 1 : 0 },
  duration: DURATION_OPACITY_TOGGLE
});
